// @ts-nocheck
import React, { Fragment, useEffect, useState } from "react";
import { Button, Form, Tooltip } from "react-bootstrap";
import CommandCenterService from "../../../service/CommandCenterService";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import MissionService from "../../../service/MissionService";
import CatalogueService from "../../../service/CatalogueService";
import {
  containsSpecialChars,
  containsWhitespace,
  navigateTo,
  validateIPv4,
} from "../../CommonComponents/CommonFunctions";
import { useNavigate } from "react-router-dom";
import { AntSwitch } from "../../CommonComponents/AntSwitch";
import { useSelector } from "react-redux";
import { MissionStore } from "../../../store/MissionSlice";
import LoaderAnimation from "./Loader/LoaderAnimation";
import dayjs from "dayjs";
import CustomToolTip from "../../CommonComponents/CustomToolTip";
import Dialog from "../../CommonComponents/Dialog";

const TrueTwinConfig = ({ mission_name, mission_id, sat_id, close }) => {
  const navigate = useNavigate();

  const userData = useSelector(
    (state: { mission: MissionStore }) => state.mission.userData
  );
  const Mission = useSelector((state: { mission: MissionStore }) => state.mission.Mission);

  const [firstLoading, setFirstLoading] = React.useState(true);
  const [getPayloads, setPayloads] = useState<any[]>([]);
  const [getTemplate, setTemplate] = useState<any>({});
  const [remotePayload, setRemotePayload] = useState<any>([]);
  const [remoteBus, setRemoteBus] = useState<any>([]);
  const [configuredBusData, setConfiguredBusData] = useState<any>([]);
  const [configuredData, setConfiguredData] = useState<any>([]);
  const [objectName, setObjectName] = useState("");
  const [objectTLE, setObjectTLE] = useState("");
  const [sat_name, setSat_name] = useState("");
  const [configStep, setConfigStep] = useState<string>(userData?.["feature-allowed"]?.["hwInLoop"] === "Yes" ? "BUS" : 'Payloads');
  const [isQuickLaunch, setIsQuickLaunch] = useState(false);
  const [isSatelliteReady, setIsSatelliteReady] = useState(false);
  const [satelliteIpAddress, setSatelliteIpAddress] = useState("");
  const [satellitePort, setSatellitePort] = useState("");
  const [activeIndex, setActiveIndex] = useState("0");
  const [gpioCount, setGpioCount] = useState<any>('');
  const [UART, setUART] = useState<any>(false);
  const [Ethernet, setEthernet] = useState<any>(false);
  const [pinValues, setPinValues] = useState([]);
  const [deviceConfig, setDeviceConfig] = useState({
    0: "",
    1: "",
  });
  const [ethernetIps, setEthernetIps] = useState({
    application: "",
    device: "",
  });
  const [gpioInterupt, setGpioInterupt] = useState("");
  const [selectedPayload, setSelectedPayload] = useState("");


  const [deployLoader, setDeployLoader] = useState<any>(false);
  const [trueTwinData, setTrueTwinData] = useState<any>({});

  const [mass, setMass] = useState<any>(null);
  const [isShowModal, setIsShowModal] = useState<any>(false)

  const ConfigSteps = [
    {
      title: "BUS",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 3L5.125 3L5.125 6.125L2 6.125L2 3ZM2 11.1257L5.125 11.1257L5.125 14.2507L2 14.2507L2 11.1257ZM22 19.2503L2 19.2503L2 21.7503L22 21.7503L22 19.2503ZM7.62505 3L10.75 3L10.75 6.125L7.62505 6.125L7.62505 3ZM10.75 11.1257L7.62505 11.1257L7.62505 14.2507L10.75 14.2507L10.75 11.1257ZM13.25 3L16.375 3L16.375 6.125L13.25 6.125L13.25 3ZM16.375 11.1257L13.25 11.1257L13.25 14.2507L16.375 14.2507L16.375 11.1257ZM18.875 3L22 3L22 6.125L18.875 6.125L18.875 3ZM22 11.1257L18.875 11.1257L18.875 14.2507L22 14.2507L22 11.1257Z"
            fill={configStep === "BUS" ? "#CCF54E" : "#ABAEAF"}
          />
        </svg>
      ),
    },
    {
      title: "Payloads",
      icon: (
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 9.5C2 9.813 2.461 10.358 3.53 10.893C4.914 11.585 6.877 12 9 12C11.123 12 13.086 11.585 14.47 10.893C15.539 10.358 16 9.813 16 9.5V7.329C14.35 8.349 11.827 9 9 9C6.173 9 3.65 8.348 2 7.329V9.5ZM16 12.329C14.35 13.349 11.827 14 9 14C6.173 14 3.65 13.348 2 12.329V14.5C2 14.813 2.461 15.358 3.53 15.893C4.914 16.585 6.877 17 9 17C11.123 17 13.086 16.585 14.47 15.893C15.539 15.358 16 14.813 16 14.5V12.329ZM0 14.5V4.5C0 2.015 4.03 0 9 0C13.97 0 18 2.015 18 4.5V14.5C18 16.985 13.97 19 9 19C4.03 19 0 16.985 0 14.5ZM9 7C11.123 7 13.086 6.585 14.47 5.893C15.539 5.358 16 4.813 16 4.5C16 4.187 15.539 3.642 14.47 3.107C13.086 2.415 11.123 2 9 2C6.877 2 4.914 2.415 3.53 3.107C2.461 3.642 2 4.187 2 4.5C2 4.813 2.461 5.358 3.53 5.893C4.914 6.585 6.877 7 9 7Z"
            fill={configStep === "Payloads" ? "#CCF54E" : "#ABAEAF"}
          />
        </svg>
      ),
    },
    {
      title: "Communication",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99953 11.0002L15.9995 20.0002H3.99953L9.99953 11.0002ZM9.99953 14.6002L7.73953 18.0002H12.2595L9.99953 14.6002ZM8.93953 8.5602C8.79216 8.42288 8.67395 8.25728 8.59197 8.07328C8.50998 7.88928 8.4659 7.69065 8.46235 7.48925C8.45879 7.28784 8.49584 7.08778 8.57128 6.90101C8.64673 6.71423 8.75902 6.54456 8.90145 6.40213C9.04389 6.25969 9.21356 6.1474 9.40033 6.07196C9.58711 5.99652 9.78717 5.95947 9.98857 5.96302C10.19 5.96657 10.3886 6.01066 10.5726 6.09264C10.7566 6.17462 10.9222 6.29283 11.0595 6.4402C11.3245 6.72455 11.4687 7.10065 11.4619 7.48925C11.455 7.87785 11.2976 8.24862 11.0228 8.52345C10.7479 8.79827 10.3772 8.9557 9.98857 8.96255C9.59997 8.96941 9.22388 8.82516 8.93953 8.5602ZM3.28053 0.783203L4.69553 2.1982C3.28919 3.6047 2.49913 5.51223 2.49913 7.5012C2.49913 9.49018 3.28919 11.3977 4.69553 12.8042L3.28053 14.2192C2.39823 13.337 1.69834 12.2897 1.22083 11.137C0.743329 9.98433 0.497559 8.74888 0.497559 7.5012C0.497559 6.25353 0.743329 5.01808 1.22083 3.86539C1.69834 2.71271 2.39823 1.66538 3.28053 0.783203ZM16.7165 0.783203C17.5988 1.66538 18.2987 2.71271 18.7762 3.86539C19.2537 5.01808 19.4995 6.25353 19.4995 7.5012C19.4995 8.74888 19.2537 9.98433 18.7762 11.137C18.2987 12.2897 17.5988 13.337 16.7165 14.2192L15.3015 12.8042C16.7079 11.3977 17.4979 9.49018 17.4979 7.5012C17.4979 5.51223 16.7079 3.6047 15.3015 2.1982L16.7165 0.783203ZM6.10953 3.6112L7.52353 5.0252C7.19849 5.35021 6.94065 5.73607 6.76473 6.16073C6.58882 6.58539 6.49828 7.04055 6.49828 7.5002C6.49828 7.95986 6.58882 8.41502 6.76473 8.83968C6.94065 9.26434 7.19849 9.65019 7.52353 9.9752L6.10953 11.3892C5.07813 10.3578 4.4987 8.95885 4.4987 7.5002C4.4987 6.04156 5.07813 4.64265 6.10953 3.6112ZM13.8875 3.6112C14.9189 4.64265 15.4984 6.04156 15.4984 7.5002C15.4984 8.95885 14.9189 10.3578 13.8875 11.3892L12.4735 9.9752C12.7986 9.65019 13.0564 9.26434 13.2323 8.83968C13.4082 8.41502 13.4988 7.95986 13.4988 7.5002C13.4988 7.04055 13.4082 6.58539 13.2323 6.16073C13.0564 5.73607 12.7986 5.35021 12.4735 5.0252L13.8875 3.6112Z"
            fill={configStep === "Comm." ? "#CCF54E" : "#ABAEAF"}
          />
        </svg>
      ),
    },
    {
      title: "Power",
      icon: (
        <svg
          width="21"
          height="14"
          viewBox="0 0 21 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.99951 14.0002H0.999512C0.734295 14.0002 0.479941 13.8949 0.292405 13.7074C0.104869 13.5198 -0.000488281 13.2655 -0.000488281 13.0002V1.00024C-0.000488281 0.735028 0.104869 0.480674 0.292405 0.293138C0.479941 0.105601 0.734295 0.000244141 0.999512 0.000244141H7.62451L6.45751 2.00024H1.99951V12.0002H5.99951V14.0002ZM10.3745 14.0002L11.5415 12.0002H15.9995V2.00024H11.9995V0.000244141H16.9995C17.2647 0.000244141 17.5191 0.105601 17.7066 0.293138C17.8942 0.480674 17.9995 0.735028 17.9995 1.00024V13.0002C17.9995 13.2655 17.8942 13.5198 17.7066 13.7074C17.5191 13.8949 17.2647 14.0002 16.9995 14.0002H10.3745ZM18.9995 4.00024H20.9995V10.0002H18.9995V4.00024ZM9.99951 6.00025H12.9995L7.99951 14.0002V8.00025H4.99951L9.99951 0.000244141V6.00025Z"
            fill={configStep === "Power" ? "#CCF54E" : "#ABAEAF"}
          />
        </svg>
      ),
    },
  ];

  const navigate_to_tt_details = () => {
    navigateTo(
      `${mission_name}/${mission_id}/${sat_name}/${sat_id}/truetwin_details/${trueTwinData?.["Name"]}/${trueTwinData?.["trueTwinId"]}/Configuration`,
      navigate
    );
  };

  const get_satellite = () => {
    MissionService.get_satellite_by_sat_id(sat_id)
      ?.then((sat) => {
        if (sat.data) {
          setMass(sat?.['data']?.['swap-info']?.['totalUsedMass'])
          CatalogueService.getTemplate(
            sat.data?.["versions"]?.[0]?.["assembly"]?.["Template"]
          )
            ?.then((temp) => {
              if (temp.data) {
                const template = temp.data;
                const pay = sat.data?.["versions"]?.[0]?.["assembly"]?.["Payloads"];
                setObjectName(sat?.data?.name);
                setSat_name(sat?.data?.name);
                setPayloads(pay);
                setTemplate(template);
                let payloadAppIds = {};
                if (sat?.data?.['satelliteConfig']?.['Payload']?.length > 0) {
                  sat?.data?.['satelliteConfig']?.['Payload']?.map(payload => {
                    payloadAppIds = {
                      ...payloadAppIds,
                      [payload?.['payloadId']]: Number(payload?.['appId'])
                    }
                  })
                }

                if (pay.length > 0) {
                  let arr: any = [];
                  pay.map((item) => {
                    const data: any = {
                      id: item?.["user_data"]?.["id"],
                      appId: payloadAppIds[item?.["user_data"]?.["id"]],
                      name: item?.["user_data"]?.["payload_name"],
                      isConfigured: remotePayload.includes(
                        item["user_data"]["id"]
                      )
                        ? "Yes"
                        : "No",
                      payloadType:
                        item?.["atmos-data"]?.[
                        "component_specific_attributes"
                        ]?.["payloadType"],
                      payloadSubType:
                        item?.["atmos-data"]?.[
                        "component_specific_attributes"
                        ]?.["payloadSubType"],
                      payloadHWName: item?.["atmos-data"]?.["name"],
                    };
                    arr.push(data);

                  });
                  setConfiguredData(arr);
                }
              }
              setFirstLoading(false);
            })
            .catch((err) => {
              console.error(err);
              setFirstLoading(false);
            });
        } else {
          toast.error("Something went wrong", { toastId: "o" });
          close();
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Something went wrong", { toastId: "o" });
        close();
      });
  };

  const configure_remote_payload = (config_payloads) => {
    if (getPayloads?.length > 0) {
      let arr: any = [];
      configuredData.map((item) => {
        if (config_payloads.includes(item.id)) {
          item.isConfigured = "Yes";
        }
        else {
          item.isConfigured = "No";
        }
        arr.push(item);
      });
    }
  };

  useEffect(() => {
    get_satellite();
  }, []);

  const undeploy_truetwin = (truetwin_id, truetwin_name) => {
    CommandCenterService.unDeployTrueTwin(truetwin_id)
      ?.then((res) => {
        if (res.data) {
          setDeployLoader({ "error": `An error occurred while deploying TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name}` });
        }
      })
      .catch((err) => {
        setDeployLoader({ "error": `An error occurred while deploying TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name}` });
      });
  };
  const dis_connect_ground_station = (TrueTwin: object) => {
    let truetwin_name = TrueTwin?.['Name']
    let truetwin_id = TrueTwin?.['trueTwinId']
    CommandCenterService.disconnectGroundStation(
      TrueTwin?.["groundStationId"],
      TrueTwin?.["trueTwinId"]
    )
      ?.then((res) => {
        if (res.data) {
          undeploy_truetwin(truetwin_id, truetwin_name);
        }
      })
      .catch((err) => {
        undeploy_truetwin(truetwin_id, truetwin_name);
        console.error(err);
      });
  };



  const run_simulation = (data: object, TrueTwin: object) => {
    let truetwin_name = TrueTwin?.['Name']
    MissionService.runSimulation(data)?.then(res => {
      if (res.data) {
        setDeployLoader({ "deployed": `TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + "..." : truetwin_name} deployed successfully.` });
      }
    }).catch(err => {
      dis_connect_ground_station(TrueTwin)
    })
  }


  const deploy_truetwin_by_launch_type = (data: object, TrueTwin: object) => {
    let truetwin_name = TrueTwin?.['Name']
    let truetwin_id = TrueTwin?.['trueTwinId']
    setDeployLoader({ "deploying": `Deploying TrueTwin ${truetwin_name?.length > 20 ? truetwin_name?.substring(0, 10) + "..." : truetwin_name}...` });
    let tt_data = {
      ...TrueTwin,
      'deployInfo': data,
    }
    CommandCenterService.deployTrueTwin(TrueTwin?.['trueTwinId'], tt_data)?.then((res) => {
      if (res.data) {
        if (TrueTwin?.['Category'] === 'TrueTwin') {
          CommandCenterService.connectGroundStation(res.data?.["groundStationId"], TrueTwin?.['trueTwinId'], data?.['scenarioId'])?.then((gsres) => {
            if (gsres?.data) {
              if (TrueTwin?.['isRemoteAppConfigured'] === 'No') {
                let body = {
                  "simulationName": "Simultion" + data?.['scenarioName'],
                  "scenarioId": data?.['scenarioId'],
                  "trueTwinId": truetwin_id,
                  "missionId": mission_id,
                  "satId": sat_id,
                }
                run_simulation(body, TrueTwin)
              } else {
                setDeployLoader({
                  'deployed': `TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name} deployed successfully.`,
                  'connecting': `Connecting to remote application...`
                })
              }
            }
          }).catch((err) => {
            dis_connect_ground_station(TrueTwin)
          });
        }
      }
    })?.catch((err) => {
      setDeployLoader({ "error": `An error occurred while deploying TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name}` });
    });
  };

  const create_new_scenario = (TrueTwin) => {
    let truetwin_name = TrueTwin?.['Name']
    let body = {
      "scenarioName": `sc-${TrueTwin?.['Name']}`,
      "missionId": mission_id,
      'satellite_name': sat_name,
      "satId": sat_id,
      "trueTwinId": TrueTwin?.['trueTwinId'],
      "duration": 120,
      'draftMode': 'No',
      "sampleRate": 1,
      "isQuickDeployFlag": "true",
      "physicalCharacteristics": {
        "mass": Number(mass)
      }
    }
    MissionService.postScenario(body)?.then((res) => {
      if (res?.data) {
        let body = {
          "epoch": parseInt(dayjs.utc(new Date()).valueOf() / 1000),
          "altitude": +Mission?.['mission-attributes']?.['Altitude_range']?.['max'],
          "eccentricity": 0,
          "inclination": +Mission?.['mission-attributes']?.['inclination_angle'],
          "RAAN": 0,
          "AP": 0,
          "TA": 0
        }
        let scenarioId = res?.data?.['scenarioId']
        let scenarioName = res?.data?.['scenarioName']
        MissionService.patchScenario(scenarioId, body).then((res) => {
          if (res?.data) {
            let data = {
              'type': 'Quick Deploy',
              'scenarioId': scenarioId,
              'scenarioName': scenarioName,
            }
            deploy_truetwin_by_launch_type(data, TrueTwin)
          }
        }).catch((err) => {
          setDeployLoader({ "error": `An error occurred while deploying TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name}` });
          console.log(err)
        })

      }
    }).catch((err) => {
      setDeployLoader({ "error": `An error occurred while deploying TrueTwin ${truetwin_name?.length > 15 ? truetwin_name?.substring(0, 15) + " ..." : truetwin_name}` });
      console.error(err)
    })
  }


  const createMissionTrueTwin = () => {
    setDeployLoader({ 'creating': `Creating TrueTwin ${objectName?.length > 20 ? objectName.substring(0, 20) + " ..." : objectName}...` });
    if (isSatelliteReady) {
      var data = {
        status: "configured",
        isDeployed: "No",
        Category: "FlatSat",
        TLE: objectTLE,
        Name: objectName,
        satId: sat_id,
        deployInfo: {
          type: "",
        },
        isRemoteAppConfigured: "No",
        remoteApp: {
          AppData: configuredData,
        },
        remoteBus: {
          AppData: configuredBusData,
        },
        satelliteIp: satelliteIpAddress,
        satellitePort: satellitePort,
      };
    } else {
      const updatedData = configuredData.map((item) => {
        if (item.id === selectedPayload) {
          return {
            id: item?.["id"],
            appId: item?.["appId"],
            name: item?.["name"],
            isConfigured: item?.["isConfigured"],
            payloadType: item?.["payloadType"],
            payloadSubType: item?.["payloadSubType"],
            payloadHWName: item?.["payloadHWName"],
            gpioInterrupt: gpioInterupt,
            gpioPort: activeIndex,
            pins: [
              { GPIO_PIN_0: pinValues[0] ? pinValues[0] : "0" },
              { GPIO_PIN_1: pinValues[1] ? pinValues[1] : "0" },
              { GPIO_PIN_2: pinValues[2] ? pinValues[2] : "0" },
              { GPIO_PIN_3: pinValues[3] ? pinValues[3] : "0" },
              { GPIO_PIN_4: pinValues[4] ? pinValues[4] : "0" },
              { GPIO_PIN_5: pinValues[5] ? pinValues[5] : "0" },
            ],
            uartPath0: deviceConfig[0],
            uartPath1: deviceConfig[1],
            payloadApplicationIP: ethernetIps.application,
            payloadDeviceIP: ethernetIps.device
          };
        }
        return item;
      });

      var data = {
        status: "configured",
        isDeployed: "No",
        Category: "TrueTwin",
        TLE: objectTLE,
        Name: objectName,
        satId: sat_id,
        deployInfo: {
          type: "",
        },
        isRemoteAppConfigured: remotePayload.length > 0 ? "Yes" : "No",
        remoteApp: {
          AppData: (gpioCount !== '' || UART || Ethernet) ? updatedData : configuredData,
        },
        remoteBus: {
          AppData: configuredBusData,
        },
        deployInfo: {
          type: "",
        },
      };
    }

    CommandCenterService.createTrueTwin(data)
      ?.then((result) => {
        if (result.data) {
          setTrueTwinData(result.data);
          create_truetwin_datastore(result.data?.["trueTwinId"]);
          if (isQuickLaunch) {
            create_new_scenario(result.data);
          } else {
            setDeployLoader({ "created": `TrueTwin ${objectName?.length > 15 ? objectName.substring(0, 15) + " ..." : objectName} created successfully.` });
            toast.success("TrueTwin created successfully", { toastId: "o" });
          }
        }
      })
      .catch((err) => {
        if (err.response?.data === "TrueTwin with same name already exists") {
          toast.error(`The name you entered is already in use for another TrueTwin.`, { toastId: 'o' });
        } else {
          toast.error('Something went wrong while creating TrueTwin', { toastId: "0" });
        }
        setDeployLoader({ "error": `An error occurred while creating TrueTwin ${objectName}.` });
      });
  };

  const create_truetwin_datastore = (truetwin_id) => {
    CommandCenterService.createDataStoreTT(truetwin_id)?.then((res) => {
      if (res.data) {
        console.log('res', res.data);
      }
    }).catch((err) => {
      console.error(err);
    })
  }

  const removeRemoteName = (name) => {
    if (configStep === "Payloads") {
      let remainingData = remotePayload.filter((item) => item !== name);
      configure_remote_payload(remainingData);
      setRemotePayload(remainingData);
    }
    if (configStep === "BUS") {
      let remainingData = remoteBus.filter((item) => item !== name);
      let remainingBus = configuredBusData.filter(
        (item) => item?.["category"] !== name
      );
      setRemoteBus(remainingData);
      setConfiguredBusData(remainingBus);
    }
  };

  const addRemoteName = (name) => {
    if (configStep === "Payloads") {
      if (remotePayload.length === 0) {
        let remainingData = [...remotePayload, name];
        configure_remote_payload(remainingData);
        setRemotePayload(remainingData);
      } else {
        toast.warning("Only one payload can be configured as remote", {
          toastId: "o",
        });
        configure_remote_payload([name]);
        setRemotePayload([name]);
      }
    }
    if (configStep === "BUS") {
      let busData = {
        category: name,
        name: "CubeADCS 3-Axis",
      };
      if (remoteBus.length === 0) {
        setRemoteBus((prev) => [...prev, name]);
        setConfiguredBusData((prev) => [...prev, busData]);
      } else {
        toast.warning("Only one bus can be configured as remote", {
          toastId: "o",
        });
        setRemoteBus([name]);
        setConfiguredBusData([busData]);
      }
    }
  };


  const handleSubmit = () => {
    if (containsWhitespace(objectName) || objectName === "") {
      toast.error("Name cannot be empty", { toastId: "o" });
    } else {
      if (isSatelliteReady) {
        // if (satelliteIpAddress && satellitePort) {
        //   if(validateIPv4(satelliteIpAddress)){
        createMissionTrueTwin();
        //   }else{
        //     toast.error('Enter a valid satellite IP address', { toastId: "o" });
        //   }
        // } else {
        //   toast.error("Satellite ip address and port is mandatory");
        // }
      } else if (remotePayload.length > 0) {
        if (Ethernet && ethernetIps.device !== '') {
          if (ethernetIps.device === ethernetIps.application) {
            toast.error('Application IP address and Device IP address cannot be same', { toastId: "o" });
          } else {
            const device_ip = ethernetIps.device.split('.').slice(0, 3).join('.');
            const application_ip = ethernetIps.application.split('.').slice(0, 3).join('.');
            if ((device_ip === application_ip) && validateIPv4(ethernetIps.device) && validateIPv4(ethernetIps.application)) {
              createMissionTrueTwin();
            } else {
              toast.error(`${(device_ip !== application_ip) ? 'Application IP address and Device IP address subnet should be same' : `Enter a valid ${!validateIPv4(ethernetIps.device) ? 'Device' : 'Application'} IP address`}`, { toastId: "o" });
            }
          }
        } else {
          createMissionTrueTwin();
        }
      } else {
        createMissionTrueTwin();
        // if (remotePayload?.length > 0) {
        // } else {
        //   toast.error(
        //     " At least one payload should be configured as remote device",
        //     { toastId: "o" }
        //   );
        // }
      }
    }
  };
  const handleSwitcherClick = (index) => {
    setActiveIndex("" + index);
  };
  const handleInputChange = (index, value) => {
    const newPinValues = [...pinValues];
    newPinValues[index] = value;
    setPinValues(newPinValues);
  };
  // Add "Thruster" to the core list manually for mapping
  const thrusterTemplate = "Thruster";
  const isFixedStateThruster = isSatelliteReady; // Thruster is always disabled when isSatelliteReady is true
  const isCheckedThruster = false; // Thruster is always unchecked when isSatelliteReady is true

  return (
    <div className="admin-form">
      {firstLoading ? (
        <CircularProgress color="inherit" />
      ) : (
        <div>
          {!deployLoader && (
            <div
              className="admin-form-card mt-8 gap-3">
              <div className="w-100 d-flex align-content-center justify-content-between">
                <span className="fs-20">Create TrueTwin</span>
                <i
                  onClick={() => { setIsShowModal(true) }}
                  className="fe fe-x-circle fs-25 cursor-pointer"
                ></i>
              </div>

              <div className="w-100 d-flex flex-column gap-3 ps-5">
                <div className="w-100 d-flex gap-3 align-items-center">
                  <span className="fs-16">Title * :</span>
                  <Form.Control
                    required
                    className="w-90"
                    type="text"
                    placeholder="Enter the TrueTwin name"
                    value={objectName !== "" ? objectName : ""}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(event) => {
                      event.preventDefault();
                      const trimmedValue = event.target.value.trimStart();
                      const isNotValidName = containsSpecialChars(trimmedValue);

                      if (isNotValidName) {
                        toast.error(
                          "TrueTwin title cannot contain special characters",
                          { toastId: "o" }
                        );
                      } else {
                        if (trimmedValue.length <= 26) {
                          setObjectName(trimmedValue);
                          //For cloning case name can exceed 26 characters so we are checking this
                        } else if (event.target.value.length < objectName.length) {
                          // Allow reducing the length (e.g., through backspace) even if the current name is too long
                          setObjectName(trimmedValue);
                        } else {
                          toast.error(
                            "TrueTwin title cannot exceed 26 characters",
                            { toastId: "o" }
                          );
                        }
                      }
                    }}
                  ></Form.Control>
                </div>
                <div className="w-100 gap-5 align-items-center d-flex">
                  {userData?.['feature-allowed']?.['validation'] === 'Yes' && (
                    <Form.Check
                      className="d-flex align-items-center gap-2"
                      style={{ paddingRight: "16px" }}
                      type="checkbox"
                      id={`default-checkbox-1`}
                      label={"Satellite Ready in Lab"}
                      checked={isSatelliteReady}
                      onChange={() => {
                        if (getTemplate?.['template-attribute']?.['sizeInUnits'] === 6) {
                          setIsSatelliteReady(!isSatelliteReady);
                          setIsQuickLaunch(false);
                          setConfigStep("BUS")
                        } else {
                          toast.warning('FlatSat mode is supported for 6U BUS only.', { toastId: '0' })
                        }
                      }}
                    />
                  )}
                  <div className="d-flex align-items-center gap-2">
                    <Form.Check
                      className="d-flex align-items-center gap-2"
                      type="checkbox"
                      id={`default-checkbox-2`}
                      label={
                        <span className="d-flex">
                          Quick Deploy
                          <CustomToolTip
                            placement="top"
                            title='Automatically configure a simple scenario.'
                          >
                            <i className="fe fe-info ms-2" />
                          </CustomToolTip>
                        </span>
                      }
                      checked={isQuickLaunch}
                      onChange={() => {
                        setIsQuickLaunch(!isQuickLaunch);
                        setIsSatelliteReady(false);
                      }}
                    />
                  </div>
                </div>
                {/* {isSatelliteReady &&
                  <div className="w-100 d-flex align-items-center justify-content-between">
                    <div className="w-50 d-flex flex-column gap-2">
                      <span className="fs-16">IP Address *</span>
                      <Form.Control
                        className="w-95 tle-entry mb-4"
                        type="text"
                        rows={3}
                        placeholder="Enter Satellite IP Address"
                        value={satelliteIpAddress}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          event.preventDefault();
                          const inputValue = event.target.value;
                          const filteredValue = inputValue.replace(/[^0-9.]/g, '');
                          filteredValue.length <= 15 ? setSatelliteIpAddress(filteredValue) :  toast.error(
                            "Invalid IP Address",
                            { toastId: "o" }
                          );
                        }}
                      />

                    </div>
                    <div className="w-50 d-flex flex-column gap-2">
                      <span className="fs-16">Port *</span>
                      <Form.Control
                        className="w-95 tle-entry mb-4"
                        type="text"
                        rows={3}
                        placeholder="Enter Satellite Port"
                        value={satellitePort}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          const inputValue = event.target.value;
                          if (/^\d*$/.test(inputValue)) {
                            if(inputValue.length <= 5){
                              setSatellitePort(inputValue);
                            }else{
                              toast.error(
                                "Invalid PORT Number",
                                { toastId: "o" }
                              );
                            }
                          }
                        }}
                      />

                    </div>
                  </div>
                } */}
              </div>
              {<span className="w-100 border-top border-primary"></span>}
              {<div className="pop-scroll p-0 pe-3 overflow-y-auto">
                <div
                  className="w-100 mb-5 d-flex gap-3 "
                  style={{
                    borderBottom: "2px solid rgba(255,255,255,0.2)",
                    height: "50px",
                  }}
                >
                  {ConfigSteps.map((item, i) => (
                    <div
                      key={i}
                      className={`h-100 w-35 d-flex gap-2 align-items-center justify-content-center ${item?.title !== 'BUS' && isSatelliteReady ? 'opacity-50' : ''}`}
                      style={{
                        borderBottom:
                          item.title === configStep ? "2px solid #CCF54E" : "",
                        cursor: "pointer",
                        marginTop: "2px",
                        pointerEvents: isSatelliteReady ? "none" : "auto",
                      }}
                      onClick={() => {
                        if (
                          item.title === "Payloads" ||
                          (userData?.["feature-allowed"]?.["hwInLoop"] ===
                            "Yes" &&
                            item.title === "BUS")
                        ) {
                          setConfigStep(item.title);
                        }
                      }}
                    >
                      <span
                        style={{
                          color: item.title === configStep ? "#CCF54E" : "gray",
                        }}
                      >
                        {item.icon}
                      </span>
                      <span
                        style={{
                          color: item.title === configStep ? "#CCF54E" : "gray",
                        }}
                      >
                        {item.title}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-wrap w-100 overflow-visible gap-3 pb-5">
                  {configStep === "BUS" &&
                    Object.keys(getTemplate)?.length > 0 &&
                    Object.keys(getTemplate?.["assembly"]?.[0]?.["core"])?.map(
                      (template, i) => {
                        if (
                          template !== "ADCS Software" &&
                          template !== "Bus OS" &&
                          template !== "iIMU" &&
                          !(
                            (template === "Bus OBC" || template === "Temperature Sensor") &&
                            isSatelliteReady
                          )
                        ) {
                          const isFixedState =
                            ((template === "ADCS" || template === "Bus OBC") && isSatelliteReady) ||
                            ((template === "GPS" || template === "Temperature Sensor") && isSatelliteReady);

                          const isChecked =
                            (template === "ADCS" || template === "Bus OBC") && isSatelliteReady
                              ? true
                              : (template === "GPS" || template === "Temperature Sensor") && isSatelliteReady
                                ? false
                                : remoteBus.includes(template);

                          return (
                            <div
                              key={i}
                              className="config-cards gap-2"
                              onClick={(e) => {
                                if (!isFixedState) {
                                  if (remoteBus.includes(template)) {
                                    removeRemoteName(template);
                                  } else {
                                    addRemoteName(template);
                                  }
                                }
                              }}
                            >
                              <div className="d-flex align-items-center">
                                <span>{template}</span>
                              </div>
                              <div className="d-flex align-items-center gap-3">
                                <span
                                  style={{
                                    color: remoteBus.includes(template) ? "gray" : "#CCF54E",
                                  }}
                                >
                                  SW-In-Loop
                                </span>
                                <AntSwitch
                                  name={template}
                                  checked={isChecked}
                                  color="success"
                                  // disabled={isFixedState} // Disable the switch if the state is fixed
                                  onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    if (!isFixedState) {
                                      if (e.target.checked) {
                                        addRemoteName(template);
                                      } else {
                                        removeRemoteName(template);
                                      }
                                    }
                                  }}
                                  inputProps={{ "aria-label": "ant design" }}
                                />
                                <span
                                  style={{
                                    color: remoteBus.includes(template) ? "#CCF54E" : "gray",
                                  }}
                                >
                                  HW-In-Loop
                                </span>
                              </div>
                            </div>
                          );
                        }
                      }
                    )}




                  {configStep === "Payloads" && (
                    <div className="d-flex w-100 h-100">
                      <div className={(gpioCount !== '' || UART || Ethernet) ? " w-300px flex flex-column gap-3" : "w-100 d-flex flex-wrap gap-3"}>
                        {getPayloads.map((payload, i) => {
                          return (
                            <div className="d-flex" key={i}>
                              <div
                                className="config-cards gap-3 "
                                style={{
                                  backgroundColor: remotePayload.includes(
                                    payload?.["user_data"]?.["id"]
                                  )
                                    ? "#21243C"
                                    : "#0F1117",
                                  minWidth: "279px",
                                }}
                                onClick={(e) => {
                                  if (remotePayload.includes(payload?.["user_data"]?.["id"])) {
                                    removeRemoteName(
                                      payload?.["user_data"]?.["id"]
                                    );
                                    setPinValues([]);
                                    setGpioInterupt("");
                                    setDeviceConfig({
                                      0: "",
                                      1: "",
                                    });
                                    setEthernetIps({
                                      application: "",
                                      device: "",
                                    });
                                    setActiveIndex("0");
                                    setSelectedPayload('')
                                    setGpioCount('');
                                    setUART(false)
                                    setEthernet(false)
                                  } else {
                                    addRemoteName(
                                      payload?.["user_data"]["id"]
                                    );
                                    setEthernet(payload?.["user_data"]?.['selected_interfaces']?.includes('Ethernet') ? true : false);
                                    setUART(payload?.["user_data"]?.['selected_interfaces']?.includes('UART') ? true : false);
                                    setGpioCount(payload?.["user_data"]?.['selected_interfaces']?.includes('GPIO') ? payload?.["user_data"]?.["gpio_count"] : '');
                                    setSelectedPayload(payload?.["user_data"]?.["id"]);
                                    setPinValues([]);
                                    setGpioInterupt("");
                                    setDeviceConfig({
                                      0: "",
                                      1: "",
                                    });
                                    setEthernetIps({
                                      application: "",
                                      device: "",
                                    });
                                    setActiveIndex("0");
                                  }
                                }}
                              >
                                <div className="d-flex gap-2 align-items-center">
                                  <img
                                    src={payload?.["atmos-data"]?.["src"]}
                                    alt={payload.type}
                                  />
                                  <span className="text-truncate">
                                    {
                                      payload?.["user_data"]?.[
                                      "payload_name"
                                      ]
                                    }
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  <AntSwitch
                                    name={
                                      payload?.["atmos-data"]?.[
                                      "component_specific_attributes"
                                      ]?.["payloadType"]
                                    }
                                    checked={remotePayload.includes(
                                      payload?.["user_data"]?.["id"]
                                    )}
                                    color="success"
                                    onKeyDown={(e) => {
                                      if (e.keyCode === 13) {
                                        e.preventDefault();
                                      }
                                    }}
                                    inputProps={{
                                      "aria-label": "ant design",
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: remotePayload.includes(
                                        payload?.["user_data"]?.["id"]
                                      )
                                        ? "#CCF54E"
                                        : "gray",
                                    }}
                                  >
                                    Remote
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {(gpioCount !== '' || UART || Ethernet) && (
                        <div className={`gpioWrapper w-600px ${((gpioCount !== '' && UART && Ethernet) || (gpioCount !== '' && UART)
                          || (gpioCount !== '' && Ethernet) || (UART && Ethernet)) ? 'h-100' : gpioCount !== '' ? gpioCount > 3 ? 'h-340' : 'h-300' : 'h-250'}`}>
                          {gpioCount !== '' && <Fragment>
                            <span className="configure_device fs-18">
                              Configure Interfaces
                            </span>
                            <div className="switcher-container">
                              <label className="switcher-label">Port </label>
                              <div className="slide-container">
                                <div className="switcher-count-container">
                                  <span className={`switcher-count ${activeIndex === "0" ? "active" : ""}`}>
                                    0
                                  </span>
                                  <span className={`switcher-count ${activeIndex === "1" ? "active" : ""}`}>
                                    1
                                  </span>
                                  <span className={`switcher-count ${activeIndex === "2" ? "active" : ""}`}>
                                    2
                                  </span>
                                  <span className={`switcher-count ${activeIndex === "3" ? "active" : ""}`}>
                                    3
                                  </span>
                                </div>
                                <div className="switcher-btn-container">
                                  <span className={`switcher-btn ${activeIndex === "0" ? "active" : ""}`}
                                    onClick={() => handleSwitcherClick(0)}
                                  ></span>
                                  <span className={`switcher-btn ${activeIndex === "1" ? "active" : ""}`}
                                    onClick={() => handleSwitcherClick(1)}
                                  ></span>
                                  <span className={`switcher-btn ${activeIndex === "2" ? "active" : ""}`}
                                    onClick={() => handleSwitcherClick(2)}
                                  ></span>
                                  <span className={`switcher-btn ${activeIndex === "3" ? "active" : ""}`}
                                    onClick={() => handleSwitcherClick(3)}
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <span className="flex fs-16 mb-2">GPIO Interrupt</span>
                            <Form.Control
                              className="w-100 mb-2"
                              required
                              type="text"
                              placeholder="Enter GPIO Interrupt Value"
                              value={gpioInterupt}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  e.preventDefault();
                                }
                              }}

                              onChange={(event) => {
                                setGpioInterupt(event.target.value);
                              }}
                            />
                            <div>
                              <span className="configure_pins">
                                Configure Pins
                              </span>
                              <div className="configure_pins_box">
                                {gpioCount !== '' && (
                                  <div className="gpio-container">
                                    {Array.from({ length: Math.ceil(gpioCount / 3) },
                                      (_, rowIndex) => (
                                        <div key={rowIndex} className="d-flex w-100" >
                                          {Array.from({ length: 3 },
                                            (_, colIndex) => {
                                              const index =
                                                rowIndex * 3 + colIndex;
                                              if (index < gpioCount) {
                                                return (
                                                  <div key={index}
                                                    className="gpio-item d-flex mb-4 w-30"
                                                  >
                                                    <span className="fs-16 mt-2">
                                                      PIN {index + 1}
                                                    </span>
                                                    <Form.Control
                                                      type="text"
                                                      className="w-60 ms-4"
                                                      value={
                                                        pinValues[index] || ""
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          index,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                );
                                              } else {
                                                return null;
                                              }
                                            }
                                          )}
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Fragment>}
                          {((gpioCount !== '' && UART) || (gpioCount !== '' && Ethernet)) && <div className="separator"></div>}
                          {UART && <Fragment>
                            <span className="configure_device">
                              Configure Device Path
                            </span>
                            <div className="configure_device_box">
                              <span className="fs-16">UART 0</span>
                              <Form.Control
                                className="w-100 mt-2"
                                required
                                type="text"
                                placeholder="/dev/ttyUSB0"
                                value={deviceConfig[0]}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 13) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(event) => {
                                  setDeviceConfig(prev => ({
                                    ...prev,
                                    0: event.target.value,
                                  }))
                                }}
                              />
                            </div>
                            <div className="configure_device_box">
                              <span className="fs-16">UART 1</span>
                              <Form.Control
                                className="w-100 mt-2"
                                required
                                type="text"
                                placeholder="/dev/ttyUSB1"
                                value={deviceConfig[1]}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 13) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(event) => {
                                  setDeviceConfig(prev => ({
                                    ...prev,
                                    1: event.target.value,
                                  }))
                                }}
                              />
                            </div>
                          </Fragment>}
                          {(Ethernet && UART) && <div className="separator"></div>}
                          {Ethernet && <Fragment>
                            <span className="configure_device w-100">
                              Configure Ethernet
                            </span>
                            <div className="configure_device_box">
                              <span className="fs-16">Device IP</span>
                              <Form.Control
                                className="w-100 mt-2"
                                required
                                type="text"
                                pattern="^(\d{1,3}\.){3}\d{1,3}$"
                                placeholder="Enter Device IP"
                                value={ethernetIps.device}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 13) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(event) => {
                                  const segments = event.target.value.split(".");
                                  setEthernetIps({
                                    application: segments.slice(0, 3).join(".") + '.',
                                    device: event.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="configure_device_box w-100">
                              <span className="fs-16">Application IP</span>
                              <Form.Control
                                className="w-100 mt-2"
                                required
                                type="text"
                                pattern="^(\d{1,3}\.){3}\d{1,3}$"
                                placeholder="Enter App Container IP"
                                value={ethernetIps.application}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 13) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(event) => {
                                  setEthernetIps(prev => ({
                                    ...prev,
                                    application: event.target.value,
                                  }));
                                }}
                              />
                            </div>
                          </Fragment>}
                        </div>
                      )}
                    </div>
                  )}

                  {configStep === "Comm." &&
                    Object.keys(getTemplate)?.length > 0 &&
                    Object.keys(
                      getTemplate?.["assembly"]?.[0]?.["communication"]?.[
                      "comm-devices"
                      ]
                    )?.map((comm, i) => {
                      if (comm !== "Battery Pack") {
                        return (
                          <div
                            key={i}
                            className="config-cards gap-2"
                            onClick={(e) => { }}
                          >
                            <div className="d-flex align-items-center">
                              <span>{comm}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <span>SW-In-Loop</span>
                              <AntSwitch
                                checked={false}
                                color="success"
                                onKeyDown={(e) => {
                                  if (e.keyCode === 13) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => { }}
                                inputProps={{ "aria-label": "ant design" }}
                              />
                              <span>HW-In-Loop</span>
                            </div>
                          </div>
                        );
                      }
                    })}

                  {configStep === "Power" &&
                    Object.keys(getTemplate)?.length > 0 &&
                    Object.keys(getTemplate?.["assembly"]?.[0]?.["power"])?.map(
                      (power, i) => {
                        if (power !== "Battery Pack") {
                          return (
                            <div
                              key={i}
                              className="config-cards gap-2"
                              onClick={(e) => { }}
                            >
                              <div className="d-flex align-items-center">
                                <span>{power}</span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <span>SW-In-Loop</span>
                                <AntSwitch
                                  checked={false}
                                  color="success"
                                  onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => { }}
                                  inputProps={{ "aria-label": "ant design" }}
                                />
                                <span>HW-In-Loop</span>
                              </div>
                            </div>
                          );
                        }
                      }
                    )}


                  {isSatelliteReady && <div
                    key={"thruster"}
                    className="config-cards gap-2"
                  >
                    <div className="d-flex align-items-center">
                      <span>{thrusterTemplate}</span>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <span
                        style={{
                          color: "gray",
                        }}
                      >
                        SW-In-Loop
                      </span>
                      <AntSwitch
                        name={thrusterTemplate}
                        checked={isCheckedThruster}
                        color="success"
                        disabled={isFixedStateThruster} // Disable the switch for Thruster
                        inputProps={{ "aria-label": "ant design" }}
                      />
                      <span
                        style={{
                          color: "gray",
                        }}
                      >
                        HW-In-Loop
                      </span>
                    </div>
                  </div>}

                </div>
              </div>}
              <span className="w-100 border-top border-primary"></span>
              <div className="w-100 d-flex align-items-center justify-content-between">
                <Button
                  variant="outline"
                  type="button"
                  // className={`d-flex align-items-center btn btn-outline-primary pt-1 pb-1 pe-8 ps-8 fs-14`}
                  onClick={close}
                >
                  {/* Reset All */}
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  className={`d-flex align-items-center btn btn-primary pt-1 pb-1 pe-8 ps-8 fs-14`}
                  onClick={() => {
                    if (isSatelliteReady) {
                      handleSubmit();
                    } else if (configStep === "BUS") {
                      setConfigStep("Payloads");
                    } else if (configStep === "Payloads") {
                      handleSubmit();
                    }
                  }}
                >
                  {configStep === "Payloads" || isSatelliteReady
                    ? "Create"
                    : "Next"}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}

      {deployLoader && (
        <LoaderAnimation
          objectName={objectName}
          close={() => {
            setDeployLoader(false);
            close()
          }}
          category={isSatelliteReady ? 'FlatSat' : 'TrueTwin'}
          state={deployLoader}
          truetwin_id={trueTwinData?.['trueTwinId']}
          mission_name={mission_name}
          mission_id={mission_id}
          sat_name={sat_name}
          sat_id={sat_id}
          goto={() => {
            navigate_to_tt_details()
          }}
          dis_connect_ground_station={dis_connect_ground_station}
        />
      )}
      <Dialog
        onClick={(event) => {
          if (event) {
            close()
          }
          setIsShowModal(false);
        }}
        openModel={isShowModal}
        comment="Are you sure you want to discard the changes?"
      />
    </div>
  );
};

export default TrueTwinConfig;
